import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Buffer } from "buffer";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";
import * as Sentry from "@sentry/react";
import { isInsideCherry } from "@cherrydotfun/miniapp-sdk";
import { CherryMiniAppProvider } from "@cherrydotfun/miniapp-sdk/react";

import "./index.css";
import "@/components/ui/styles.css";
import { QueryProvider } from "./lib/providers/QueryProvider.tsx";
import { CustomPrivyProvider } from "./lib/providers/privy-provider.tsx";
import { AppRouterProvider } from "./lib/providers/RouterProvider.tsx";
import configs from "./lib/configs/index.ts";
import { ConvexClientProvider } from "@/lib/providers/ConvexClientProvider";
import { MoonPayCrashBoundary } from "@/components/MoonPayCrashBoundary";
import { CherryAuthBridge } from "@/components/CherryAuthBridge";
import { PrivyXOAuthTokenProvider } from "@/lib/providers/PrivyXOAuthTokenProvider";

// Polyfill Buffer for Solana libraries
window.Buffer = Buffer;

// Detect Cherry embed synchronously at module load
const isCherryEmbed = isInsideCherry({ strict: true }) || isInsideCherry();

// if (
//   import.meta.env.MODE === "development" ||
//   window.location.search.includes("debug")
// ) {
//   import("eruda").then((eruda) => eruda.default.init());
// }

Sentry.init({
  dsn: "https://9dea72375efc83c7288db542f50ecb9e@o4511219440615424.ingest.us.sentry.io/4511219445137408",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Enable logs to be sent to Sentry
  enableLogs: true,
});

posthog.init(configs.POSTHOG.KEY, {
  api_host: configs.POSTHOG.HOST,
  ui_host: "https://us.posthog.com",
  defaults: "2025-05-24",
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
});

createRoot(document.getElementById("root")!, {
  // onUncaughtError: (error) => posthog.captureException(error),
  // onCaughtError: (error) => posthog.captureException(error),
  // onRecoverableError: (error) => posthog.captureException(error),
}).render(
  isCherryEmbed ? (
    <PostHogProvider client={posthog}>
      <QueryProvider>
        <MoonPayCrashBoundary>
          <CustomPrivyProvider>
            <PrivyXOAuthTokenProvider>
              <CherryMiniAppProvider>
                <CherryAuthBridge>
                  <ConvexClientProvider>
                    <AppRouterProvider />
                  </ConvexClientProvider>
                </CherryAuthBridge>
              </CherryMiniAppProvider>
            </PrivyXOAuthTokenProvider>
          </CustomPrivyProvider>
        </MoonPayCrashBoundary>
      </QueryProvider>
    </PostHogProvider>
  ) : (
    <StrictMode>
      <PostHogProvider client={posthog}>
        <QueryProvider>
          <MoonPayCrashBoundary>
            <CustomPrivyProvider>
              <PrivyXOAuthTokenProvider>
                <ConvexClientProvider>
                  <AppRouterProvider />
                </ConvexClientProvider>
              </PrivyXOAuthTokenProvider>
            </CustomPrivyProvider>
          </MoonPayCrashBoundary>
        </QueryProvider>
      </PostHogProvider>
    </StrictMode>
  ),
);
